const removeQueryParameters = (url: string) => {
  const urlObj = new URL(url);
  const cleanUrl = urlObj.origin + urlObj.pathname;
  return cleanUrl;
};

export default removeQueryParameters;
